<template>
  <div class="kldn-ghost-grid">
    <!-- 1 -->
    <div class="kldn-ghost-grid__col">
      <div class="kldn-ghost-grid__line"></div>
    </div>

    <!-- 2 -->
    <div class="kldn-ghost-grid__col">
      <div class="kldn-ghost-grid__line"></div>
    </div>

    <!-- 3 -->
    <div class="kldn-ghost-grid__col">
    </div>

    <!-- 4 -->
    <div class="kldn-ghost-grid__col">
      <div class="kldn-ghost-grid__line"></div>
    </div>

    <!-- 5 -->
    <div class="kldn-ghost-grid__col">
      <div class="kldn-ghost-grid__line kldn-ghost-grid__line_right-only"></div>
    </div>

    <!-- 6 -->
    <div class="kldn-ghost-grid__col">
      <div class="kldn-ghost-grid__line kldn-ghost-grid__line_right"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
  }
</script>

<style lang="styl" src="./index.styl"></style>



// WEBPACK FOOTER //
// src/components/GhostGrid/index.vue